import { makeStyles } from '@mui/styles';
import React from 'react';

import ItemsListLayout from './ItemsListLayout';
import ItemsTable from './ItemsTable';
import RecentItemsList from '../../components/EditorDashboard/RecentItemsList';
import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  main: {
    padding: 20,
    backgroundColor: '#fff',
  },
});

const EditorDashboard = ({
  dashboardTitle,
  itemName,
  itemTitle,
  navigateToItemEditor,
  itemQuantity,
  customCell,
  isLoading,
  items,
  entityName,
  initialSearchName,
  dashboardLink,
  dashboardType,
  importFile,
  extraColumns,
  runSavedSearchConfig,
  isRunModalOpen,
  setIsRuntModalOpen,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const title = translateString(dashboardTitle);

  return (
    <ItemsListLayout
      dashboardLink={dashboardLink}
      pageTitle={title}
      isLoading={isLoading}
      itemName={itemName}
      dashboardType={dashboardType}
      importFile={importFile}
      runSavedSearchConfig={runSavedSearchConfig}
      isRunModalOpen={isRunModalOpen}
      setIsRuntModalOpen={setIsRuntModalOpen}
    >
      <div className={classes.main}>
        <RecentItemsList
          items={items}
          navigateToItemEditor={navigateToItemEditor}
          itemTitle={translateString(itemTitle)}
          itemQuantity={itemQuantity}
          dashboardType={dashboardType}
        />
        <ItemsTable
          entityName={entityName}
          initialSearchName={initialSearchName}
          itemTitle={translateString(initialSearchName)}
          customCell={customCell}
          extraColumns={extraColumns}
        />
      </div>
    </ItemsListLayout>
  );
};
export default EditorDashboard;
